const loadingLabel = "Prebieha načítavanie…";
const skSK = {
  loadingLabel
};
export {
  skSK as default,
  loadingLabel
};
